import { withStyles, withTheme } from "@material-ui/core/styles";
import { getCombinedIcons } from '@dataGrid/components/cellRenderer/SpecialNeedsRenderer';
import { getSvgIcons } from "../../../../../modules/Dispatch/utils/iconsUtil";
import { getAptComments } from "../../../../../modules/Dispatch/utils/utils";
import MapPopupTooltip from "../MapPopupTooltip";
import { compose } from "recompose";

const styles = {
  iconsContainer: {
    height: "100%",
    display: "table",
    float: "right",
  },
  iconStyle: {
    verticalAlign: "middle",
    display: "table-cell",
  },
};

const SpecialNeeds = ({ classes, stopData, values, specialNeeds, theme }) => {
  const iconsList = getCombinedIcons(
    {
      value: values,
      data: stopData,
      getAptComments: getAptComments
    },
    specialNeeds
  );
  const getIcon = (icons) => {
    if (icons.isSvgIcon) {
      return getSvgIcons({iconName: icons.icon,backgroundColor:theme.TextColor});
    }
    return <i className={`${icons.icon}`} />;
  };
  return (
    <div className={classes.iconsContainer}>
      {iconsList.map((icons, index) => (
        <MapPopupTooltip key={index} title={icons.tooltip}>
          <div className={classes.iconStyle}>{getIcon(icons)}</div>
        </MapPopupTooltip>
      ))}
    </div>
  );
};

export default compose(withStyles(styles),withTheme())(SpecialNeeds);
